import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Install the `}<inlineCode parentName="p">{`posthog-rs`}</inlineCode>{` crate by adding it to your `}<inlineCode parentName="p">{`Cargo.toml`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-toml",
        "metastring": "file=Cargo.toml",
        "file": "Cargo.toml"
      }}>{`[dependencies]
posthog-rs = "0.3.5"
`}</code></pre>
    <p>{`Next, set up the client with your PostHog project key.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rust"
      }}>{`let client = posthog_rs::client(env!("<ph_project_api_key>"));
`}</code></pre>
    <h3 {...{
      "id": "blocking-client"
    }}>{`Blocking client`}</h3>
    <p>{`Our Rust SDK supports both blocking and async clients. The async client is the default and is recommended for most use cases.`}</p>
    <p>{`If you need to use a synchronous client instead – like we do in our `}<a parentName="p" {...{
        "href": "https://github.com/PostHog/posthog/tree/master/cli"
      }}>{`CLI`}</a>{` –, you can opt into it by disabling the asynchronous feature on your `}<inlineCode parentName="p">{`Cargo.toml`}</inlineCode>{` file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-toml"
      }}>{`[dependencies]
posthog-rs = { version = "0.3.5", default-features = false }
`}</code></pre>
    <p>{`In blocking mode, calls to `}<inlineCode parentName="p">{`capture`}</inlineCode>{` and related methods will block until the PostHog event capture API returns – generally this is on the order of tens of milliseconds, but you may want to `}<inlineCode parentName="p">{`thread::spawn`}</inlineCode>{` a background thread when you send an event.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      